/**
 * Build /smswiser/:country deep links for prepared-drop investigation.
 */

export type PreparedDropLookupPayload = {
  preparedDropId: string;
  countryKey: string;
  wiserId: number;
  workDate: string;
  status: string;
  sentDropId: number | null;
  sentDropUniqueId: string | null;
  executeAfter: string | null;
};

export function buildSmswiserPreparedInvestigationPath(p: PreparedDropLookupPayload): string {
  const params = new URLSearchParams({
    view: 'prepared',
    wiserId: String(p.wiserId),
    workDate: p.workDate,
    preparedSubTab: 'sent',
    focusPreparedDrop: p.preparedDropId,
  });
  return `/smswiser/${encodeURIComponent(p.countryKey)}?${params.toString()}`;
}
